module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAABHNCSVQICAgIfAhkiAAAALBJREFUKJGNUTsWwyAMkzmRgewhJ4OcLHTvhxPFHSAPCmlTjZZtyTKhA/PkQOIhEgEgpefa8vTRrO0GABBagX0GUQAQ0+ux9IvBbDyz8UNd262tq6pFbthyqDWcaigHqFvfn9I9Zm4ciMA+n1nNXD9QpFu/OTEKR2JAnxIbX5Jpb1iKrd9gntxZnaq0DJFWlfpEKjZcftY3NGGwtnLpr7hgbTd13Zpx/ENBJPw7BJHwBic+RMnCWMPTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/SsendHead.png
// module id = JlC3
// module chunks = 1